import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getUserRoles } from '../PrivateRoute';

/** Preserve non-tenant workflows; client routing never grants API authorization. */
export default function TenantLegacyRoute({ to, children }: { to: string; children: React.ReactNode }) {
  const location = useLocation();
  return getUserRoles().includes('tenant')
    ? <Navigate to={`${to}${location.search}${location.hash}`} replace />
    : <>{children}</>;
}

const TABS: Record<string, string> = {
  browse: 'browse', saved: 'saved', enquiries: 'enquiries', requests: 'property-requests',
  conversations: 'conversations', notifications: 'notifications', subscription: 'subscription',
  referrals: 'referrals', profile: 'profile', verification: 'verification', 'change-password': 'change-password',
};
export function TenantDashboardEntry({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tab = query.get('tab');
  if (tab && TABS[tab]) {
    query.delete('tab');
    const search = query.toString();
    return <Navigate to={`/tenant/${TABS[tab]}${search ? `?${search}` : ''}${location.hash}`} replace />;
  }
  return <>{children}</>;
}
export function TenantProfileEntry({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  return location.hash === '#kyc'
    ? <Navigate to={`/tenant/verification${location.search}`} replace />
    : <>{children}</>;
}

export function TenantIndexRoute() {
  const location = useLocation();
  return <Navigate to={`dashboard${location.search}${location.hash}`} replace />;
}
